export const skipEmptyFilters = <T extends Record<string, unknown>>(filters: T, recursive = false): Partial<T> => {
  const newFilters: Partial<T> = {};

  (Object.keys(filters) as (keyof T)[]).forEach((key) => {
    const value = filters[key];

    const isNestedObject = typeof value === 'object' && value !== null && !Array.isArray(value);
    if (recursive && isNestedObject) {
      const cleanedValue = skipEmptyFilters(value as Record<string, unknown>, true);

      if (Object.keys(cleanedValue).length > 0) {
        newFilters[key] = cleanedValue as T[keyof T];
      }
      return;
    }
    if (Array.isArray(value)) {
      if (value.length > 0 && value[0] === '') {
        return;
      }
    }

    const isEmpty = value === null || value === 'null' || value === '' || value === 'all';

    if (!isEmpty) {
      newFilters[key] = value;
    }
  });

  return newFilters;
};
